/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolInventory2Icon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-inventory-2"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.85 22.8Q3.73 22.8 2.96 22.04Q2.2 21.27 2.2 20.15L2.2 8.65Q1.75 8.3 1.48 7.76Q1.2 7.22 1.2 6.58L1.2 3.85Q1.2 2.73 1.96 1.96Q2.73 1.2 3.85 1.2L20.15 1.2Q21.27 1.2 22.04 1.96Q22.8 2.73 22.8 3.85L22.8 6.58Q22.8 7.22 22.52 7.76Q22.25 8.3 21.8 8.65L21.8 20.15Q21.8 21.27 21.04 22.04Q20.27 22.8 19.15 22.8ZM3.83 6.6L20.18 6.6Q20.18 6.6 20.18 6.6Q20.18 6.6 20.18 6.6L20.18 3.85Q20.18 3.85 20.18 3.85Q20.18 3.85 20.18 3.85L3.83 3.85Q3.83 3.85 3.83 3.85Q3.83 3.85 3.83 3.85L3.83 6.6Q3.83 6.6 3.83 6.6Q3.83 6.6 3.83 6.6ZM10.07 14.68L13.95 14.68Q14.53 14.68 14.91 14.29Q15.3 13.9 15.3 13.32Q15.3 12.75 14.91 12.36Q14.53 11.97 13.95 11.97L10.07 11.97Q9.5 11.97 9.11 12.36Q8.72 12.75 8.72 13.32Q8.72 13.9 9.11 14.29Q9.5 14.68 10.07 14.68Z" fill={color} />
    </svg>
  );
}
